import { DesktopView, MobileView } from '../ScreenViews'
import DesktopMenu from './DesktopMenu'
import MobileMenu from './MobileMenu'
import React from 'react'

const Menu = () => {
  return (
    <>
      <MobileView>
        <MobileMenu />
      </MobileView>
      <DesktopView>
        <DesktopMenu />
      </DesktopView>
    </>
  )
}

export default Menu
